import { ComboChart } from '../../charts/ComboChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import { CURRENCY_AXIS_WIDTH, moneyFormatter } from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IRevenueTrendChartProps {
  facts: IComponentFacts;
}

const LABELS = { revenue: 'Revenue', movingAverage: '3-mo avg' };

export const RevenueTrendChart = ({ facts }: IRevenueTrendChartProps) => {
  const months = useTrendMonths(facts, { allowPreliminary: true });
  const style = useChartStyle(2);
  const rows = ChartModelHelper.revenueTrend(facts.table, months);
  if (!ChartModelHelper.hasSeries(rows, 'revenue')) return <EmptyFacts />;
  const formatter = moneyFormatter(facts.currency);
  return (
    <ComboChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(rows, LABELS)}
      index="label"
      barSeries={{
        categories: [LABELS.revenue],
        colors: ['blue'],
        valueFormatter: formatter,
        yAxisWidth: CURRENCY_AXIS_WIDTH,
      }}
      lineSeries={{
        categories: [LABELS.movingAverage],
        colors: ['emerald'],
        valueFormatter: formatter,
        showYAxis: false,
        connectNulls: true,
      }}
    />
  );
};
